import { render, staticRenderFns } from "./navabar.vue?vue&type=template&id=80516444&scoped=true&"
import script from "./navabar.vue?vue&type=script&lang=js&"
export * from "./navabar.vue?vue&type=script&lang=js&"
import style0 from "./navabar.vue?vue&type=style&index=0&id=80516444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80516444",
  null
  
)

export default component.exports